import { QueueComponentInterface } from '../../../../../interfaces/pagebuilder';
import NoSettingsPlaceholder from '../../NoSettingsPlaceholder';

interface QueueSettingsTableInterface {
  component: QueueComponentInterface;
  onChange: (c: QueueComponentInterface) => void;
}

const QueueSettingsTable = ({ component, onChange }: QueueSettingsTableInterface) => {
  return <NoSettingsPlaceholder />;
};
export default QueueSettingsTable;
